import { PaymentConst, TaxRateLiterals } from "@graffer-inc/cloud-gov-core";
import { BaseValue } from "../base/base-value";
import { RefundRequestItemValidator } from "./refund-request-item-validator";

export type RefundRequestJSON = {
  items: RefundRequestItemJSON[];
  message: string;
};

export type RefundRequestItemJSON = {
  refundableAmount: number;
  refundAmount: number;
  taxRate: TaxRateLiterals;
  description: string;
};

export type RefundRequestAPI = {
  paymentIndex: number;
  version: number;
  totalAmount: number;
  items: {
    amount: number;
    taxRate: TaxRateLiterals;
    description: string;
  }[];
  message?: string;
};

export class RefundRequest extends BaseValue<RefundRequestJSON> {
  get items() {
    return this.value.items;
  }

  updateMessage(msg: string) {
    this.value.message = msg;
    return this;
  }

  messageError() {
    return this.value.message.length > PaymentConst.MAX_PAYMENT_MESSAGE_LENGTH
      ? "メッセージは300文字以内で入力してください。"
      : undefined;
  }

  update(item: RefundRequestItemJSON, index: number) {
    this.value.items = this.value.items.map((i, idx) =>
      idx === index ? item : i,
    );
    return this;
  }

  copy() {
    return new RefundRequest(JSON.parse(JSON.stringify(this.value)));
  }

  getTotalRefundAmount() {
    return this.value.items.reduce((pv, cv) => pv + cv.refundAmount, 0);
  }

  isValid() {
    return (
      this.getTotalRefundAmount() > 0 &&
      !this.items.some(
        (v) => new RefundRequestItemValidator(v).validate().amount,
      )
    );
  }

  toAPI(args: {
    paymentIndex: number;
    version: number;
    message?: string;
  }): RefundRequestAPI {
    return {
      ...args,
      totalAmount: this.getTotalRefundAmount(),
      items: this.getValue().items.map((v) => ({
        amount: v.refundAmount,
        description: v.description,
        taxRate: v.taxRate,
      })),
    };
  }

  static fromJSON(v: RefundRequestJSON) {
    return new RefundRequest(v);
  }
}
